import {
  fieldSecureBusinessOffers,
  fieldSmartCameraOffers, fieldTelusSecureBusinessSecurityPackage,
  ignoredKeysOfSelectedItems,
  keyControlAdditionalEquipment,
  keyMonitorAdditionalEquipment,
  keyProtectAdditionalEquipment,
  keySecurityCameraEquipment,
  smartCameraKey,
  valueControl,
  valueMonitor,
  valueProtect
} from '../../../utils/constant';
import { getLocale } from '../../../misc';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';
import { getFieldValue } from '../../utils';

const locale = getLocale();
const {
  contentfulValues: {
    secureBusinessOffers: {
      waivedInstallationFee
    }
  }
} = locale === 'en-US' ? EN : FR;

// SOF-2981: Add the following logic based on number of additional equipment selected.
// These are discounts on the installation fee.
// If 0 additional devices - remove $350 from one time total
// If 1-3 additional devices - remove $250 from one time total
// If 4-10 additional devices - remove $150 from one time total
// If 11+ no discount should apply
const getInstallationFeeDiscount = (qty) => {
  if (qty === 0) return 350;
  if (qty > 0 && qty < 4) return 250;
  if (qty > 3 && qty < 11) return 150;
  return 0;
};

const getNumberOfSelectedItems = (obj) => {
  if (!obj) return 0;

  const getNumber = (acc, key) => {
    const amount = obj[key].value ? +obj[key].value : 0;
    return acc + amount;
  };

  return Object.keys(obj)
    .filter((key) => !ignoredKeysOfSelectedItems.includes(key))
    .reduce(getNumber, 0);
};

const updateInstallationFeeDiscount = (fields, installationFeeDiscount) => {
  if (!fields) return;
  const { options, value } = fields;

  // Delete previous Installation Fee offer
  const installationFeeOptionIndex = options.findIndex((option) => option.fields.value === waivedInstallationFee);
  if (installationFeeOptionIndex > -1) {
    options.splice(installationFeeOptionIndex, 1);
    if (Array.isArray(value)) {
      const installationFeeIndex = value.findIndex((i) => i === waivedInstallationFee);
      if (installationFeeIndex > -1) {
        value.splice(installationFeeIndex, 1);
      }
    }
  }

  // Add new Installation Fee offer
  if (installationFeeDiscount > 0) {
    options.push({
      fields: {
        label: `$${installationFeeDiscount} ${waivedInstallationFee}`,
        value: waivedInstallationFee,
        oneTimePrice: -1 * installationFeeDiscount,
        disabledOption: true
      }
    });
    if (Array.isArray(value)) {
      const installationFeeIndex = value.findIndex((i) => i === waivedInstallationFee);
      if (installationFeeIndex === -1) {
        value.push(waivedInstallationFee);
      }
    }
  }
};

const calcInstallationFeeDiscount = (obj) => {
  const fieldTelusSecureBusinessSecurityPackageValue = getFieldValue(
    fieldTelusSecureBusinessSecurityPackage,
    obj
  );

  if (!fieldTelusSecureBusinessSecurityPackageValue) return undefined;

  let formFieldsPackageKey = fieldSecureBusinessOffers;
  let formFieldsEquipmentKey;
  switch (fieldTelusSecureBusinessSecurityPackageValue) {
    case smartCameraKey:
      formFieldsPackageKey = fieldSmartCameraOffers;
      formFieldsEquipmentKey = keySecurityCameraEquipment;
      break;
    case valueProtect:
      formFieldsEquipmentKey = keyProtectAdditionalEquipment;
      break;
    case valueControl:
      formFieldsEquipmentKey = keyControlAdditionalEquipment;
      break;
    case valueMonitor:
      formFieldsEquipmentKey = keyMonitorAdditionalEquipment;
      break;
    default:
  }

  const numberOfSelectedItems = getNumberOfSelectedItems(obj[formFieldsEquipmentKey]);
  const discountAmount = getInstallationFeeDiscount(numberOfSelectedItems);
  updateInstallationFeeDiscount(obj[formFieldsPackageKey], discountAmount);

  return discountAmount;
};

const setDisabledOptions = (options, targets, value) => {
  targets.forEach((target) => {
    options.forEach(option => {
      if (option.fields.value === target) {
        // eslint-disable-next-line no-param-reassign
        option.fields.disabledOption = value;
      }
    });
  });
};

export {
  getInstallationFeeDiscount,
  calcInstallationFeeDiscount,
  getNumberOfSelectedItems,
  setDisabledOptions
};